import { CeruleanButton } from 'components/Button'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import SelectOption from 'components/SelectOption'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { FormSection } from 'redux-form'
import styled from 'styled-components'
import { color, fontSize, validator } from 'utils'

import Container from '../Modal/Container'

const AtLeastOneChecked = (value, allValues) => {
  const { intentions } = allValues
  if (
    !intentions ||
    (!intentions.BUY_CRYPTO_FOR_FIAT &&
      !intentions.OCCASIONAL_TRADES &&
      !intentions.SEMI_FREQUENT_TRADING &&
      !intentions.HIGH_FREQUENT_TRADING)
  ) {
    return true
  }
}

const CheckBoxLabel = styled.p`
  color: ${color('dark200')};
  font-size: ${fontSize('xs')};
  font-weight: 600;
  margin: 0;
`

const CheckBoxLabelSub = styled(CheckBoxLabel)`
  margin: 0 0 2rem;
  font-weight: 500;
`

type Props = {
  steps: number
  valid: boolean
} & WrappedComponentProps

const Edd = ({ intl, steps, valid }: Props) => {
  return (
    <Container
      current={steps - 1}
      sub={intl.formatMessage(messages.sub_title_edd)}
      title={intl.formatMessage(messages.title_edd)}
      total={steps}
    >
      <InputContainer>
        <Field
          component={SelectOption}
          e2e='sourceOfFunds'
          items={[
            {
              text: 'Select an answer'
            },
            {
              text: 'Salary',
              value: 'SALARY'
            },
            {
              text: 'Crypto Trading',
              value: 'CRYPTO_TRADING'
            },
            {
              text: 'Crypto Mining',
              value: 'CRYPTO_MINING'
            },
            {
              text: 'Investment Income',
              value: 'INVESTMENT_INCOME'
            },
            {
              text: 'Real Estate',
              value: 'REAL_ESTATE'
            },
            {
              text: 'Inheritance',
              value: 'INHERITANCE'
            }
          ]}
          label={intl.formatMessage(messages.label_edd_funds)}
          name='sourceOfFunds'
          validate={[validator.required]}
          variant='normal'
          weight={600}
        />
      </InputContainer>
      <InputContainer>
        <Field
          component={SelectOption}
          e2e='expectedVolume'
          items={[
            {
              text: 'Select an answer'
            },
            {
              text: '<$10k',
              value: 'BELOW_10K'
            },
            {
              text: '$10-$50k',
              value: 'BELOW_50K'
            },
            {
              text: '$50k-$100k',
              value: 'BELOW_100K'
            },
            {
              text: '$100k-$250k',
              value: 'BELOW_250K'
            },
            {
              text: '$250k+',
              value: 'ABOVE_250K'
            }
          ]}
          label={intl.formatMessage(messages.label_edd_volume)}
          name='expectedVolume'
          validate={[validator.required]}
          variant='normal'
          weight={600}
        />
      </InputContainer>
      <CheckBoxLabel>{intl.formatMessage(messages.label_edd_intentions_title)}</CheckBoxLabel>
      <CheckBoxLabelSub>{intl.formatMessage(messages.label_edd_intentions_sub)}</CheckBoxLabelSub>
      <FormSection name='intentions'>
        <InputContainer>
          <Field
            component={Input}
            e2e='eddIntention1Checkbox'
            label={intl.formatMessage(messages.label_edd_intention_1)}
            name='BUY_CRYPTO_FOR_FIAT'
            type='checkbox'
            validate={AtLeastOneChecked}
            variant='createApiKey'
          />
        </InputContainer>
        <InputContainer>
          <Field
            component={Input}
            e2e='eddIntention2Checkbox'
            label={intl.formatMessage(messages.label_edd_intention_2)}
            name='OCCASIONAL_TRADES'
            type='checkbox'
            variant='createApiKey'
          />
        </InputContainer>
        <InputContainer>
          <Field
            component={Input}
            e2e='eddIntention3Checkbox'
            label={intl.formatMessage(messages.label_edd_intention_3)}
            name='SEMI_FREQUENT_TRADING'
            type='checkbox'
            variant='createApiKey'
          />
        </InputContainer>
        <InputContainer>
          <Field
            component={Input}
            e2e='eddIntention4Checkbox'
            label={intl.formatMessage(messages.label_edd_intention_4)}
            name='HIGH_FREQUENT_TRADING'
            type='checkbox'
            variant='createApiKey'
          />
        </InputContainer>
      </FormSection>
      <CeruleanButton disabled={!valid} e2e='continueButton' type='submit'>
        {intl.formatMessage(messages.submit)}
      </CeruleanButton>
    </Container>
  )
}

export default injectIntl(Edd)
